import dateUtils from '../../../_helpers/dateUtils'

const DateString = (path) => (rowData) =>
  rowData[path] ? dateUtils.formatDateString(rowData[path]) : ''

export default DateString
